import React, { FunctionComponent } from "react"

interface HeartIconProps {
  color?: string
}

const HeartIcon: FunctionComponent<HeartIconProps> = ({
  color = "#FFC200",
}) => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9238 6.88873C23.9238 3.25539 20.9785 0.310059 17.3458 0.310059C15.1405 0.310059 13.1945 1.39873 12.0005 3.06273C10.8065 1.39873 8.86048 0.310059 6.65582 0.310059C3.02248 0.310059 0.0771484 3.25473 0.0771484 6.88873C0.0771484 7.40339 0.142482 7.90206 0.254482 8.38273C1.16782 14.0581 7.47782 20.0454 12.0005 21.6894C16.5225 20.0454 22.8331 14.0581 23.7451 8.38339C23.8585 7.90273 23.9238 7.40406 23.9238 6.88873Z"
        fill={color}
      />
    </svg>
  )
}

export default HeartIcon
